import axios from 'axios';
import { fetchData } from './utils';
import { getUserId, getUsergender } from '../utils/auth';

const baseUrl = process.env.REACT_APP_BASE_URL;

export const submitUserResponses = async (userResponses, token) => {
    try {
      await axios.post(`${baseUrl}/user_responses/`, userResponses, {
        params: {
          schema: 'public',
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error('Error submitting user responses:', error);
      throw error;
    }
  };

export const submitAssessmentOutcome = async (assessmentOutcome, token) => {
    try {
      await axios.post(`${baseUrl}/user_responses_outcome/`, assessmentOutcome, {
        params: {
          schema: 'public',
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error('Error submitting assessment outcome:', error);
      throw error;
    }
  };

  export const submitAbdominalResponses = async (userAbdominalResponses, token) => {
    try {
      const userId = userAbdominalResponses.user_id;
  
      // First, check if an assessment exists for the user
      const response = await axios.get(`${baseUrl}/medical_assessment/abdominal/${userId}`, {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${token}` },
      });
  
      if (response.data) {
        const assessmentId = response.data.id;

        // Create a new object without `created_at` and `created_by` for updates
        const { created_at, created_by, ...updatedResponses } = userAbdominalResponses;
  
        // Add updated fields
        updatedResponses.updated_at = new Date().toISOString();
        updatedResponses.updated_by = userId;
  
        // Use PUT to update the existing assessment
        await axios.put(`${baseUrl}/medical_assessment/abdominal/`, updatedResponses, {
          params: {id:assessmentId, schema: "public" },
          headers: { Authorization: `Bearer ${token}` },
        });
  
      } else {
        throw new Error("No data returned from GET request.");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
  
        // If GET request returns 404, use POST to create a new assessment
        await axios.post(`${baseUrl}/medical_assessment/abdominal/`, userAbdominalResponses, {
          params: { schema: "public" },
          headers: { Authorization: `Bearer ${token}` },
        });  
      } else {
        console.error("Error submitting assessment response:", error);
        throw error;
      }
    }
  };

  export const submitPrediabetesResponses = async (userPrediabetesResponses, token) => {
    try {
      const userId = userPrediabetesResponses.user_id;
  
      // First, check if an assessment exists for the user
      const response = await axios.get(`${baseUrl}/medical_assessment/abdominal/${userId}`, {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${token}` },
      });
  
      if (response.data) {
        const assessmentId = response.data.id;

        // Create a new object without `created_at` and `created_by` for updates
        const { created_at, created_by, ...updatedResponses } = userPrediabetesResponses;
  
        // Add updated fields
        updatedResponses.updated_at = new Date().toISOString();
        updatedResponses.updated_by = userId;
        updatedResponses.gender = response.data.gender;

  
        // Use PUT to update the existing assessment
        await axios.put(`${baseUrl}/medical_assessment/prediabetes/`, updatedResponses, {
          params: {id:assessmentId, schema: "public" },
          headers: { Authorization: `Bearer ${token}` },
        });
  
      } else {
        throw new Error("No data returned from GET request.");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // If GET request returns 404, use POST to create a new assessment
        await axios.post(`${baseUrl}/medical_assessment/prediabetes/`, userPrediabetesResponses, {
          params: { schema: "public" },
          headers: { Authorization: `Bearer ${token}` },
        });  
      } else {
        console.error("Error submitting assessment response:", error);
        throw error;
      }
    }
  };

  export const submitIRResponses = async (userIRResponses, token) => {
    try {
      const userId = userIRResponses.user_id;
  
      // First, check if an assessment exists for the user
      const response = await axios.get(`${baseUrl}/medical_assessment/ir/${userId}`, {
        params: { schema: "public" },
        headers: { Authorization: `Bearer ${token}` },
      });
  
      if (response.data) {
        const assessmentId = response.data.id;

        // Create a new object without `created_at` and `created_by` for updates
        const { created_at, created_by, ...updatedResponses } = userIRResponses;
  
        // Add updated fields
        updatedResponses.updated_at = new Date().toISOString();
        updatedResponses.updated_by = userId;
  
        // Use PUT to update the existing assessment
        await axios.put(`${baseUrl}/medical_assessment/ir/`, updatedResponses, {
          params: {id:assessmentId, schema: "public" },
          headers: { Authorization: `Bearer ${token}` },
        });
  
      } else {
        throw new Error("No data returned from GET request.");
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
  
        // If GET request returns 404, use POST to create a new assessment
        await axios.post(`${baseUrl}/medical_assessment/ir/`, userIRResponses, {
          params: { schema: "public" },
          headers: { Authorization: `Bearer ${token}` },
        });  
      } else {
        console.error("Error submitting assessment response:", error);
        throw error;
      }
    }
  };

  export const fetchOutcomeData = async (endpoint, params = {}, access_token) => {
    
    try {
      const response = await axios.get(`${baseUrl}/${endpoint}`, {
        params,
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        withCredentials: true,
      });
      return response.data; 
      
    } catch (error) {
      if (error.response?.status === 404) {
        console.warn(`404 Not Found: ${endpoint}`);
        return [];
      }
      console.error(`Error fetching data from ${endpoint}:`, error.response?.data || error.message);
      return null;
    }
  };
  

  export const fetchAssessmentCards = async (access_token, userId, parent_assessment_id) => {
    try {
      const [cardsData, outcomesData] = await Promise.all([
        fetchData('assessments/parent', {p_assessment_id: parent_assessment_id, schema: 'public' }, access_token),

        fetchOutcomeData('user_responses_outcome/filter/user/', { user_id: userId, schema: 'public' }, access_token)
      ]);  
      const cards = cardsData && cardsData.length > 0 
        ? cardsData.map(item => ({ id: item.id, title: item.name, content: item.description }))
        : [];
  
      // const outcomesMap = outcomesData.reduce((acc, outcome) => {
      //   if (outcome.status === 'completed') {
      //     acc[outcome.assessment_id] = outcome;
      //   }
      //   return acc;
      // }, {});
      const outcomesMap = outcomesData 
  ? outcomesData.reduce((acc, outcome) => {
      if (outcome.status === 'completed') {
        acc[outcome.assessment_id] = outcome;
      }
      return acc;
    }, {}) 
  : {}; // Ensure outcomesData is not null before using reduce
  
      return { cards, outcomesMap };
    } catch (error) {
      return { cards: [], outcomesMap: {} };
    }
  };
  
export const fetchAssessmentOutcomes = async (access_token, userId) => {
    try {
      // const outcomesData = await fetchData('user_responses_outcome', { user_id: userId, schema: 'public', skip:0, limit:20 }, access_token);
  
      const outcomesData = await fetchOutcomeData('user_responses_outcome/filter/user/', { user_id: userId, schema: 'public' }, access_token)

      // Already returning the mapped outcomes object
      // const outcomesMap = outcomesData.reduce((acc, outcome) => {
      //   if (outcome.status === 'completed') {
      //     acc[outcome.assessment_id] = outcome;
      //   }
      //   return acc;
      // }, {});
  
      // return outcomesMap;
      const outcomesMap = Array.isArray(outcomesData) 
  ? outcomesData.reduce((acc, outcome) => {
      if (outcome.status === 'completed') {
        acc[outcome.assessment_id] = outcome;
      }
      return acc;
    }, {}) 
  : {};
  return outcomesMap;
    } catch (error) {
      console.error('Error in fetchAssessmentOutcomes:', error);
      return {};  // Return empty object instead of { outcomesMap: {} }
    }
};  

export const fetchIsAssessmentEnabled = async(userId, access_token) => {
  try{
    const isAssessmentEnabled = await fetchData(`is_assessment_enabled/filter/`,
            { user_id: userId, schema: "public" },
            access_token
          );
          return isAssessmentEnabled;
        }catch(error){
          console.error('Error in fetching assesment outcome details')
        }
}

export const fetchOutcomesByAsssessmentAndUserId = async(assessmentId, userId, access_token) => {
  try{
    const outcomeData = await fetchData(`user_responses_outcome/`,
            { assessment_id: assessmentId, user_id: userId, schema: "public" },
            access_token
          );
          return outcomeData;
        }catch(error){
          console.error('Error in fetching assesment outcome details')
        }
}
  
  export const fetchParentAssessmentDetails = async (parentAssessmentId, access_token) => {
    try {
      const parentAssessmentDetails = await fetchData(`parent_assessments/${parentAssessmentId}`,{schema: 'public'}, access_token);
      return parentAssessmentDetails
    } catch (error) {
      console.error(error);
      return []
    }
  };

  export const fetchParentAssessmentCards = async (access_token) => {
    try {
      const parentCardsData = await fetchData('parent_assessments', { skip: 0, limit: 10, schema: 'public' }, access_token);
      return parentCardsData
    } catch (error) {
      console.error(error);
      return []
    }
  };

  export const fetchQuestionsAndOptions = async (activeCard, access_token) => {
    try {
      // Fetch all questions first
      const questionsData = await fetchData("questions/filter", { id: activeCard, schema: "public" }, access_token);
  
      // Extract all question IDs that need options
      const questionIds = questionsData
        .filter((q) => q.question_type !== "text_input")
        .map((q) => q.id)
        .join(","); // Convert to CSV string for API request
  
      let optionsData = {};

  
      if (questionIds.length > 0) {
        // Fetch options for all questions in one request
        optionsData = await fetchData("options/question_ids", { ids: questionIds, schema: "public" }, access_token);
      }
  
      return { questions: questionsData, options: optionsData };
    } catch (error) {
      throw new Error("Failed to load questions and options.");
    }
  };
  
  export const fetchUserResponses = async (assessment_id, access_token) => {
    try {
      // First fetch all questions for this assessment
      const questionsData = await fetchData(
        "questions/filter", 
        { id: assessment_id, schema: "public" }, 
        access_token
      );

      if (!questionsData || !questionsData.length) {
        return [];
      }

      const userId = getUserId();
      
      // Fetch responses for these questions
      const responseData = await fetchData(
        "user_responses/questionids/", 
        { 
          question_ids: questionsData.map(q => q.id).join(','),
          user_id: userId,
          schema: "public" 
        }, 
        access_token
      );

      // Create a questions map for quick lookup
      const questionsMap = questionsData.reduce((acc, question) => {
        acc[question.id] = question;
        return acc;
      }, {});

      // Transform the response data
      const formattedResponses = [];
      
      if (responseData && typeof responseData === 'object') {
        Object.entries(responseData).forEach(([questionId, responses]) => {
          if (Array.isArray(responses) && responses.length > 0) {
            const question = questionsMap[questionId];
            if (question) {
              responses.forEach(response => {
                formattedResponses.push({
                  question_text: question.question_text,
                  question_type: question.question_type,
                  section: question.section,
                  response: response.response,
                  score: response.score,
                  created_at: response.created_at,
                  question_id: questionId,
                  response_id: response.id
                });
              });
            }
          }
        });
      }

      return formattedResponses.sort((a, b) => {
        if (a.created_at && b.created_at) {
          return new Date(b.created_at) - new Date(a.created_at);
        }
        return 0;
      });

    } catch (error) {
      console.error('Error fetching user responses:', error);
      throw error;
    }
  };
  
export const updateUserResponses = async (assessment_id, updateData, access_token) => {
  try {
    const userId = getUserId();

    // Step 1: Fetch existing user responses
    const existingResponses = await fetchUserResponses(assessment_id, access_token);

    if (!existingResponses || existingResponses.length === 0) {
      throw new Error("No existing responses found for this assessment.");
    }

    // Step 2: Create a map of { user_id, question_id } -> response_id
    const responseMap = new Map();
    existingResponses.forEach(response => {
      responseMap.set(`${response.question_id}_${userId}`, response.response_id);
    });

    // Step 3: Map updateData to include response_id
    const validUpdates = updateData.map(entry => {
      const responseId = responseMap.get(`${entry.question_id}_${entry.user_id}`) || null;
      return responseId 
          ? { ...entry }  // Keep all fields except 'id'
          : null;
  }).filter(entry => entry !== null); // Remove null entries
  
  const responseIds = validUpdates.map(entry => responseMap.get(`${entry.question_id}_${entry.user_id}`));
  
  // Ensure responseIds exist
  if (responseIds.length === 0) {
      throw new Error("No matching responses found to update.");
  }
  

    // Step 4: Prepare request body in required format
    const requestBody = {
      ids: responseIds, // Extract all response IDs
      updated_entries: validUpdates, // Updated response data
    };

    // Step 5: Send the PUT request
    const updateResponse = await axios.put(`${baseUrl}/user_responses/bulk/`, requestBody, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });

    return updateResponse.data;
  } catch (error) {
    console.error("Error updating user responses:", error);
    throw error;
  }
};

export const decodeData = (data) => {
  if (!data) return { name: "Unknown" };

  try {
    const decoded = JSON.parse(atob(data)); // Decodes Base64  
    return typeof decoded === "object" && decoded?.name ? { name: decoded.name } : { name: "Unknown" };
  } catch (error) {
    console.error("Decoding Error:", error);
    return { name: "Unknown" };
  }
};

export const updateAssessmentOutcome = async (assessmentId,userId, assessmentOutcome, access_token) => {

  try {
    const outcomeDataPresent = await fetchOutcomesByAsssessmentAndUserId(assessmentId, userId, access_token);
    let outcomeId = '';
    if(outcomeDataPresent){
      outcomeId = outcomeDataPresent.id
    }
    await axios.put(`${baseUrl}/user_responses_outcome?id=${outcomeId}`, assessmentOutcome, {
      params: {
        schema: 'public',
      },
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  } catch (error) {
    console.error('Error submitting assessment outcome:', error);
    throw error;
  }
};

export const fetchAbdominalAssessmentResponse = async(userId, access_token) => {
  const userResponses = await fetchData(
    `medical_assessment/abdominal/${userId}`, 
    { schema: "public" }, 
    access_token
  );

  if (!userResponses) {
    return [];
  }
  return userResponses;
}

export const fetchPrediabetesAssessmentResponse = async(userId, access_token) => {
  const userResponses = await fetchData(
    `medical_assessment/prediabetes/${userId}`, 
    { schema: "public" }, 
    access_token
  );

  if (!userResponses) {
    return [];
  }
  return userResponses;
}

export const fetchIRAssessmentResponse = async(userId, access_token) => {
  const userResponses = await fetchData(
    `medical_assessment/ir/${userId}`, 
    { schema: "public" }, 
    access_token
  );

  if (!userResponses) {
    return [];
  }
  return userResponses;
}